import { Box, Grid, styled } from "@mui/material";

import DepositExtraInfo from "./DepositExtraInfo";
import DepositHiddenQrCode from "./DepositHiddenQrCode";
import DepositQrCode from "./DepositQrCode";
import DepositText from "./DepositText";

const ResultToShow = ({ selectedWallet }) => {
  const showHiddenQrCode = selectedWallet?.isShowAddressLater;

  const showQrCode =
    selectedWallet?.address && !isNaN(+selectedWallet?.address);

  const showText = !showQrCode;

  if (showQrCode) {
    return <DepositQrCode selectedWallet={selectedWallet} />;
  } else if (showHiddenQrCode) {
    return <DepositHiddenQrCode selectedWallet={selectedWallet} />;
  } else if (showText) {
    return <DepositText selectedWallet={selectedWallet} />;
  } else {
    return <>Something Went Wrong</>;
  }
};

function DepositResult({ selectedCoin, selectedWallet }) {
  return (
    <Grid item xs={12}>
      <BoxCore>
        <ResultToShow selectedWallet={selectedWallet} />
      </BoxCore>

      <DepositExtraInfo
        selectedWallet={selectedWallet}
        selectedCoin={selectedCoin}
      />
    </Grid>
  );
}

const BoxCore = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  border: `1px solid ${theme.palette.modules.border}`,
  boxShadow: "none",
  padding: "15px",
  borderRadius: "10px",
  direction: "rtl",
  textAlign: "right",
  marginTop: theme.spacing(2),
  ul: {
    li: {
      textAlign: "right",
      color: theme.palette.text.main,
      display: "block",
    },
  },
}));

export default DepositResult;
